"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMenu = void 0;
exports.defaultMenu = [
    {
        name: 'Property Guides',
        subItems: [
            {
                name: 'Renting',
                url: 'https://devnew.okay.com/en-US/guides/renting',
                current: false,
            }, {
                name: 'Buying',
                url: 'https://devnew.okay.com/en-US/guides/buying',
                current: false,
            }, {
                name: 'Selling',
                url: 'https://devnew.okay.com/en-US/guides/selling',
                current: false,
            },
        ],
    }, {
        name: 'Hong Kong District Guides',
        subItems: [
            {
                name: 'Hong Kong Island',
                url: 'https://devnew.okay.com/en-US/guides/hong-kong-island',
                current: false,
            }, {
                name: 'Kowloon',
                url: 'https://devnew.okay.com/en-US/guides/kowloon',
                current: true,
            }, {
                name: 'New Territories',
                url: 'https://devnew.okay.com/en-US/guides/new-territories',
                current: false,
            }, {
                name: 'Outlying Islands',
                url: 'https://devnew.okay.com/en-US/guides/outlying-islands',
                current: false,
            },
        ],
    }, {
        name: 'Useful Information',
        subItems: [
            {
                name: 'Living in Hong Kong',
                url: 'https://devnew.okay.com/en-US/guides/living-in-hong-kong',
                current: false,
            }, {
                name: 'Moving to Hong Kong',
                url: 'https://devnew.okay.com/en-US/guides/moving-to-hong-kong',
                current: false,
            }, {
                name: 'Government',
                url: 'https://devnew.okay.com/en-US/guides/government',
                current: false,
            }, {
                name: 'Culture',
                url: 'https://devnew.okay.com/en-US/guides/culture',
                current: false,
            }, {
                name: 'Children',
                url: 'https://devnew.okay.com/en-US/guides/children',
                current: false,
            }, {
                name: 'Religion',
                url: 'https://devnew.okay.com/en-US/guides/religion',
                current: false,
            }, {
                name: 'Transportation',
                url: 'https://devnew.okay.com/en-US/guides/transportation',
                current: false,
            }, {
                name: 'Healthcare',
                url: 'https://devnew.okay.com/en-US/guides/healthcare',
                current: false,
            }, {
                name: 'Pets',
                url: 'https://devnew.okay.com/en-US/guides/pets',
                current: false,
            }, {
                name: 'Banking & Financial Services',
                url: 'https://devnew.okay.com/en-US/guides/banking-financial-services',
                current: false,
            }, {
                name: 'Education',
                url: 'https://devnew.okay.com/en-US/guides/education',
                current: false,
            },
        ],
    },
];
